<template>
  <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <circle fill="#FA5543" cx="9.5" cy="9.5" r="9.5" />
      <path
        d="M9.466 14.423a1.003 1.003 0 0 1-.798-.83.68.68 0 0 1 0-.298.992.992 0 0 1 .834-.835.68.68 0 0 1 .298 0 .992.992 0 0 1 .835.835.68.68 0 0 1 0 .297 1 1 0 0 1-.806.831.828.828 0 0 1-.363 0ZM8.648 8.443v-3h2v6h-2z"
        fill="#E7E7E7"
      />
    </g>
  </svg>
</template>
